var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 41,
    viewBox: "0 0 168 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.58273 40.9118C4.51799 40.9118 3.48201 40.7405 2.5036 40.3979C1.52518 40.0553 0.690648 39.5414 0 38.8277L1.43885 36.5437C2.01439 37.0862 2.64748 37.5144 3.33813 37.8285C4.02878 38.1425 4.77698 38.2852 5.64029 38.2852C6.64748 38.2852 7.53957 37.9998 8.28777 37.4288C9.03597 36.8578 9.72662 35.8871 10.4173 34.4596L11.9137 31.1193L12.259 30.6339L21.6691 9.56421H24.7194L13.2374 35.002C12.6043 36.4866 11.8849 37.6286 11.1079 38.5136C10.3309 39.3701 9.4964 39.9982 8.60432 40.3408C7.68345 40.712 6.67626 40.9118 5.58273 40.9118ZM11.6835 32.9464L1.1223 9.59276H4.34532L13.6691 30.4341L11.6835 32.9464Z",
    fill: "url(#paint0_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.036 32.2896V9.59253H32.1439V32.3181H29.036V32.2896Z",
    fill: "url(#paint1_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.777 32.2896V0.199707H43.8849V32.2896H40.777ZM43.223 26.4084L43.3094 22.4685L57.554 9.59257H61.3525L51.2806 19.1567L49.5252 20.6413L43.223 26.4084ZM58.5324 32.2896L48.9784 20.47L50.9928 18.1004L62.3309 32.2896H58.5324Z",
    fill: "url(#paint2_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.4388 32.5181C71.7122 32.5181 70.2446 32.2326 68.9784 31.6616C67.7122 31.0906 66.7338 30.3198 66.0719 29.3205C65.41 28.3213 65.0647 27.1793 65.0647 25.8946C65.0647 24.724 65.3525 23.6391 65.928 22.6684C66.5035 21.6977 67.4244 20.9269 68.7194 20.3274C70.0143 19.7278 71.741 19.4423 73.928 19.4423H81.8129V21.7263H74.0143C71.7985 21.7263 70.2733 22.126 69.41 22.8968C68.5467 23.6677 68.1151 24.6384 68.1151 25.8089C68.1151 27.0936 68.633 28.15 69.6402 28.9208C70.6474 29.6917 72.0863 30.0914 73.928 30.0914C75.6834 30.0914 77.1798 29.6917 78.446 28.8923C79.7122 28.0929 80.633 26.9509 81.2086 25.4663L81.8992 27.579C81.3237 29.0921 80.3165 30.2627 78.8776 31.1763C77.4388 32.0613 75.6258 32.5181 73.4388 32.5181ZM81.3237 32.2897V27.2649L81.1798 26.437V18.0719C81.1798 16.1305 80.633 14.646 79.5395 13.6182C78.446 12.5904 76.8345 12.0479 74.6762 12.0479C73.1798 12.0479 71.7697 12.3049 70.446 12.7902C69.1223 13.2756 67.9712 13.9322 67.0503 14.7316L65.669 12.4476C66.8201 11.4769 68.2302 10.7061 69.8417 10.1637C71.482 9.62121 73.1798 9.36426 74.9928 9.36426C77.9568 9.36426 80.2589 10.1066 81.8705 11.5626C83.482 13.0186 84.2877 15.2455 84.2877 18.2147V32.3182H81.3237V32.2897Z",
    fill: "url(#paint3_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M89.1511 12.1336V9.59271H103.309V12.1336H89.1511ZM93.2375 32.2898V6.73774C93.2375 4.71071 93.8418 3.08337 95.0216 1.85573C96.2015 0.628094 97.9281 0 100.173 0C101.036 0 101.899 0.114199 102.705 0.342597C103.511 0.570994 104.201 0.942141 104.748 1.42749L103.712 3.71147C103.281 3.34032 102.763 3.05482 102.187 2.85497C101.612 2.65513 100.978 2.56948 100.317 2.56948C99.0216 2.56948 98.0144 2.94062 97.295 3.65437C96.6044 4.36811 96.259 5.453 96.259 6.85194V10.3065L96.3454 11.7339V32.2898H93.2375Z",
    fill: "url(#paint4_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M116.834 32.5181C114.59 32.5181 112.604 32.0327 110.849 31.0335C109.093 30.0343 107.712 28.6639 106.705 26.8938C105.698 25.1237 105.18 23.1538 105.18 20.9269C105.18 18.6429 105.698 16.6444 106.705 14.9029C107.712 13.1614 109.093 11.8195 110.849 10.8488C112.604 9.87815 114.59 9.36426 116.834 9.36426C119.108 9.36426 121.122 9.8496 122.878 10.8488C124.633 11.8481 126.014 13.1899 127.022 14.9029C128.029 16.6159 128.518 18.6144 128.518 20.8984C128.518 23.1538 128.029 25.1523 127.022 26.8938C126.014 28.6353 124.633 30.0057 122.849 31.005C121.065 32.0042 119.079 32.5181 116.834 32.5181ZM116.834 29.7773C118.504 29.7773 119.971 29.4062 121.237 28.6639C122.504 27.9216 123.54 26.8938 124.259 25.552C124.978 24.2101 125.381 22.6684 125.381 20.8984C125.381 19.0997 125.007 17.558 124.259 16.2162C123.511 14.9029 122.504 13.8466 121.237 13.1328C119.971 12.3905 118.504 12.0194 116.863 12.0194C115.223 12.0194 113.784 12.3905 112.489 13.1328C111.223 13.8751 110.187 14.9029 109.439 16.2162C108.691 17.5295 108.316 19.0997 108.316 20.8984C108.316 22.6684 108.691 24.2101 109.439 25.552C110.187 26.8938 111.194 27.9216 112.46 28.6639C113.755 29.4062 115.194 29.7773 116.834 29.7773Z",
    fill: "url(#paint5_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M146.532 9.36426C148.403 9.36426 150.014 9.70685 151.424 10.4206C152.835 11.1343 153.928 12.1907 154.734 13.6467C155.54 15.1028 155.942 16.9014 155.942 19.0997V32.2897H152.835V19.4138C152.835 17.0156 152.23 15.217 151.022 13.9893C149.813 12.7617 148.115 12.1621 145.928 12.1621C144.288 12.1621 142.878 12.4762 141.669 13.1328C140.46 13.7895 139.54 14.7316 138.878 15.9592C138.216 17.1869 137.899 18.6715 137.899 20.3845V32.3182H134.791V9.59266H137.755V15.8165L137.266 14.646C137.986 12.9901 139.165 11.7053 140.748 10.7632C142.417 9.82105 144.317 9.36426 146.532 9.36426Z",
    fill: "url(#paint6_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M165.899 5.02471C165.324 5.02471 164.835 4.82486 164.403 4.42516C164 4.02547 163.799 3.54012 163.799 2.94058C163.799 2.36958 164 1.88424 164.403 1.45599C164.806 1.05629 165.295 0.856445 165.899 0.856445C166.475 0.856445 166.964 1.05629 167.396 1.45599C167.799 1.85569 168 2.34103 168 2.94058C168 3.51157 167.799 3.99692 167.396 4.42516C166.964 4.82486 166.475 5.02471 165.899 5.02471ZM164.317 32.2897V9.59267H167.424V32.3183H164.317V32.2897Z",
    fill: "url(#paint7_linear_34_32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.58273 40.9118C4.51799 40.9118 3.48201 40.7405 2.5036 40.3979C1.52518 40.0553 0.690648 39.5414 0 38.8277L1.43885 36.5437C2.01439 37.0862 2.64748 37.5144 3.33813 37.8285C4.02878 38.1425 4.77698 38.2852 5.64029 38.2852C6.64748 38.2852 7.53957 37.9998 8.28777 37.4288C9.03597 36.8578 9.72662 35.8871 10.4173 34.4596L11.9137 31.1193L12.259 30.6339L21.6691 9.56421H24.7194L13.2374 35.002C12.6043 36.4866 11.8849 37.6286 11.1079 38.5136C10.3309 39.3701 9.4964 39.9982 8.60432 40.3408C7.68345 40.712 6.67626 40.9118 5.58273 40.9118ZM11.6835 32.9464L1.1223 9.59276H4.34532L13.6691 30.4341L11.6835 32.9464Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.036 32.2896V9.59253H32.1439V32.3181H29.036V32.2896Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.777 32.2896V0.199707H43.8849V32.2896H40.777ZM43.223 26.4084L43.3094 22.4685L57.554 9.59257H61.3525L51.2806 19.1567L49.5252 20.6413L43.223 26.4084ZM58.5324 32.2896L48.9784 20.47L50.9928 18.1004L62.3309 32.2896H58.5324Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M73.4388 32.5181C71.7122 32.5181 70.2446 32.2326 68.9784 31.6616C67.7122 31.0906 66.7338 30.3198 66.0719 29.3205C65.41 28.3213 65.0647 27.1793 65.0647 25.8946C65.0647 24.724 65.3525 23.6391 65.928 22.6684C66.5035 21.6977 67.4244 20.9269 68.7194 20.3274C70.0143 19.7278 71.741 19.4423 73.928 19.4423H81.8129V21.7263H74.0143C71.7985 21.7263 70.2733 22.126 69.41 22.8968C68.5467 23.6677 68.1151 24.6384 68.1151 25.8089C68.1151 27.0936 68.633 28.15 69.6402 28.9208C70.6474 29.6917 72.0863 30.0914 73.928 30.0914C75.6834 30.0914 77.1798 29.6917 78.446 28.8923C79.7122 28.0929 80.633 26.9509 81.2086 25.4663L81.8992 27.579C81.3237 29.0921 80.3165 30.2627 78.8776 31.1763C77.4388 32.0613 75.6258 32.5181 73.4388 32.5181ZM81.3237 32.2897V27.2649L81.1798 26.437V18.0719C81.1798 16.1305 80.633 14.646 79.5395 13.6182C78.446 12.5904 76.8345 12.0479 74.6762 12.0479C73.1798 12.0479 71.7697 12.3049 70.446 12.7902C69.1223 13.2756 67.9712 13.9322 67.0503 14.7316L65.669 12.4476C66.8201 11.4769 68.2302 10.7061 69.8417 10.1637C71.482 9.62121 73.1798 9.36426 74.9928 9.36426C77.9568 9.36426 80.2589 10.1066 81.8705 11.5626C83.482 13.0186 84.2877 15.2455 84.2877 18.2147V32.3182H81.3237V32.2897Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M89.1511 12.1336V9.59271H103.309V12.1336H89.1511ZM93.2375 32.2898V6.73774C93.2375 4.71071 93.8418 3.08337 95.0216 1.85573C96.2015 0.628094 97.9281 0 100.173 0C101.036 0 101.899 0.114199 102.705 0.342597C103.511 0.570994 104.201 0.942141 104.748 1.42749L103.712 3.71147C103.281 3.34032 102.763 3.05482 102.187 2.85497C101.612 2.65513 100.978 2.56948 100.317 2.56948C99.0216 2.56948 98.0144 2.94062 97.295 3.65437C96.6044 4.36811 96.259 5.453 96.259 6.85194V10.3065L96.3454 11.7339V32.2898H93.2375Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M116.834 32.5181C114.59 32.5181 112.604 32.0327 110.849 31.0335C109.093 30.0343 107.712 28.6639 106.705 26.8938C105.698 25.1237 105.18 23.1538 105.18 20.9269C105.18 18.6429 105.698 16.6444 106.705 14.9029C107.712 13.1614 109.093 11.8195 110.849 10.8488C112.604 9.87815 114.59 9.36426 116.834 9.36426C119.108 9.36426 121.122 9.8496 122.878 10.8488C124.633 11.8481 126.014 13.1899 127.022 14.9029C128.029 16.6159 128.518 18.6144 128.518 20.8984C128.518 23.1538 128.029 25.1523 127.022 26.8938C126.014 28.6353 124.633 30.0057 122.849 31.005C121.065 32.0042 119.079 32.5181 116.834 32.5181ZM116.834 29.7773C118.504 29.7773 119.971 29.4062 121.237 28.6639C122.504 27.9216 123.54 26.8938 124.259 25.552C124.978 24.2101 125.381 22.6684 125.381 20.8984C125.381 19.0997 125.007 17.558 124.259 16.2162C123.511 14.9029 122.504 13.8466 121.237 13.1328C119.971 12.3905 118.504 12.0194 116.863 12.0194C115.223 12.0194 113.784 12.3905 112.489 13.1328C111.223 13.8751 110.187 14.9029 109.439 16.2162C108.691 17.5295 108.316 19.0997 108.316 20.8984C108.316 22.6684 108.691 24.2101 109.439 25.552C110.187 26.8938 111.194 27.9216 112.46 28.6639C113.755 29.4062 115.194 29.7773 116.834 29.7773Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M146.532 9.36426C148.403 9.36426 150.014 9.70685 151.424 10.4206C152.835 11.1343 153.928 12.1907 154.734 13.6467C155.54 15.1028 155.942 16.9014 155.942 19.0997V32.2897H152.835V19.4138C152.835 17.0156 152.23 15.217 151.022 13.9893C149.813 12.7617 148.115 12.1621 145.928 12.1621C144.288 12.1621 142.878 12.4762 141.669 13.1328C140.46 13.7895 139.54 14.7316 138.878 15.9592C138.216 17.1869 137.899 18.6715 137.899 20.3845V32.3182H134.791V9.59266H137.755V15.8165L137.266 14.646C137.986 12.9901 139.165 11.7053 140.748 10.7632C142.417 9.82105 144.317 9.36426 146.532 9.36426Z",
    fill: "#CC349A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M165.899 5.02471C165.324 5.02471 164.835 4.82486 164.403 4.42516C164 4.02547 163.799 3.54012 163.799 2.94058C163.799 2.36958 164 1.88424 164.403 1.45599C164.806 1.05629 165.295 0.856445 165.899 0.856445C166.475 0.856445 166.964 1.05629 167.396 1.45599C167.799 1.85569 168 2.34103 168 2.94058C168 3.51157 167.799 3.99692 167.396 4.42516C166.964 4.82486 166.475 5.02471 165.899 5.02471ZM164.317 32.2897V9.59267H167.424V32.3183H164.317V32.2897Z",
    fill: "#CC349A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_32",
    x1: -4.56774,
    y1: 19.5114,
    x2: 187.272,
    y2: 19.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_32",
    x1: -4.56769,
    y1: 19.5112,
    x2: 187.272,
    y2: 19.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_32",
    x1: -4.56775,
    y1: 19.5112,
    x2: 187.272,
    y2: 19.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34_32",
    x1: -4.56778,
    y1: 19.5113,
    x2: 187.272,
    y2: 19.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34_32",
    x1: -4.56772,
    y1: 19.5114,
    x2: 187.272,
    y2: 19.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34_32",
    x1: -4.5678,
    y1: 19.5113,
    x2: 187.272,
    y2: 19.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34_32",
    x1: -4.56779,
    y1: 19.5113,
    x2: 187.272,
    y2: 19.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34_32",
    x1: -4.56744,
    y1: 19.5113,
    x2: 187.272,
    y2: 19.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8001F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f515ec6810ff17e0cc69995d5c90ab83.svg";
export { ForwardRef as ReactComponent };